export interface IResourceBundles {
    [key: string]: { read: Function };
}

export interface IContentBlocks {
    [key: string]: { read: Function };
}

export interface IAppConfig {
    apiAwsHost: string;
    appName: string;
    baseName: string;
    environment: string;
    logLevel: string;
    logger: string;
    objectCacheUrl: string;
    resourceBundles: IResourceBundles;
    contentBlocks: IContentBlocks;
    wso2ApiHost: string;
    wso2ApiUrl: string;
    wso2OpenApiUrl: string;
}

export enum WhitelabelPartner {
    NONE = '',
    DANSK_BILBRANCHERÅD = 'DANSK_BILBRANCHERÅD',
    NORDEA = 'NORDEA',
    DINERO = 'DINERO',
}

export const WhitelabelPartnerLabel: Record<string, string> = {
    DANSK_BILBRANCHERÅD: 'Dansk Bilbrancherad',
    NORDEA: 'Nordea',
    DINERO: 'Dinero',
};
